import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

const linkGroups = [
  {
    title: "shop & support",
    links: [
      ["/shop", "shop"],
      ["/about", "about"],
      ["/contact", "contact"],
      ["/faq", "faqs"],
      ["/policies", "all store policies"],
    ],
  },
  {
    title: "orders",
    links: [
      ["/orders", "orders & cancellations"],
      ["/payments", "payment policy"],
      ["/pricing", "pricing, taxes & duties"],
      ["/shipping", "shipping & delivery"],
      ["/returns", "returns & refunds"],
      ["/warranty", "product warranty"],
      ["/product-safety", "product safety & recalls"],
      ["/promotions", "promotions policy"],
    ],
  },
  {
    title: "legal & privacy",
    links: [
      ["/privacy", "privacy policy"],
      ["/data-choices", "privacy choices"],
      ["/cookies", "cookie policy"],
      ["/terms", "terms of service"],
      ["/acceptable-use", "acceptable use"],
      ["/intellectual-property", "intellectual property"],
      ["/accessibility", "accessibility"],
      ["/complaints", "complaints & disputes"],
      ["/site-notice", "website notice"],
    ],
  },
];

function Footer() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        <div className="footer-container footer-link-grid">
          {linkGroups.map((group) => (
            <section className="footer-section" key={group.title}>
              <h2 className="footer-title">{group.title}</h2>
              <nav className="footer-nav" aria-label={group.title}>
                {group.links.map(([path, label]) => (
                  <Link key={path} to={path} onClick={toTop}>
                    {label}
                  </Link>
                ))}
              </nav>
            </section>
          ))}

          <section className="footer-section footer-brand-section">
            <h2 className="footer-title">tunrisefield</h2>
            <p className="footer-about-text">
              thoughtfully selected notebooks, planners, paper, ink, and writing
              accessories.
            </p>
            <p className="footer-email">
              <a href="mailto:mall@tunrisefield.xyz">mall@tunrisefield.xyz</a>
              <br />
              Valle Morelia 120, Valle Soleado (FOMERREY-107), 67114 Guadalupe,
              N.L., MX
            </p>
            <div
              className="payment-methods"
              aria-label="Commonly supported card networks"
            >
              <span>VISA</span>
              <span>Mastercard</span>
              <span>AMEX</span>
              <span>Discover</span>
            </div>
          </section>
        </div>
      </div>

      <div className="footer-copyright">
        <div className="footer-container">
          <p>
            <span>2026 tunrisefield</span>
            <span aria-hidden="true">·</span>
            <Link to="/policies" onClick={toTop}>
              policy center
            </Link>
            <span aria-hidden="true">·</span>
            <Link to="/contact" onClick={toTop}>
              contact
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
